import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OptionsService {
  public endpoint: string = `${environment.apiUrl}/locations`;

  constructor(
    private _http: HttpClient,
  ) {

  }

  onGetOptions(): Observable<any> {
    return this._http.get<any>(`${this.endpoint}`)
  }

  onUpdateSettings(form): Observable<any> {
    return this._http.put<any>(`${this.endpoint}`, {
      form
    });
  }

  onArchiveProducts(res) {
    return this._http.get<any>(`${this.endpoint}/archive-products`).pipe(first()).subscribe((data) => {
    });
  }

  onToggleInvoice(res) {
    return this._http.patch<any>(`${this.endpoint}/invoice`, {
      locEnableCountToInvoice: res
    }).pipe(first()).subscribe((data) => {
    });
  }

  onToggleMasterCategories(checked) {
    return this._http.patch<any>(`${this.endpoint}/master-categories`, {
      locEnableMasterCategories: checked
    }).pipe(first()).subscribe();
  }
}
